<template>
    <div class="upload-dbc-file">
        <el-upload
                class="upload-dbc"
                :class="{'upload-dbc-readonly':!canEdit}"
                action="fakeaction"
                ref="uploadDBC"
                accept=".dbc"
                :file-list="fileList"
                :multiple="false"
                :on-change="handleChange"
                :on-remove="handleRemove"
                :on-success="handleSuccess"
                :on-error="handleError"
                :on-start="checkName"
                :http-request="uploadFile"
                :auto-upload="false"
                >
            <el-button v-if="!selectDone" class="dbc-button" slot="trigger" size="small" type="primary"  >{{$t('globalText.select')}}</el-button>
        </el-upload>
        <el-button v-if="fileList.length > 0 && !uploadFailed" class="dbc-button" size="small" type="primary" @click="submitUpload" :loading="isUploading">{{$t('vehicleModel.upload')}}</el-button>
     
     </div>


</template>

<script>
    export default {
        name: "UploadDBCFile",
        data(){
            return{
                selectDone:false,
                urlData:null,
                fileList:[],
                isUploading:false,
                uploadFailed:false,
                
            }
        },
        props:{
            MainModel:{type:String,default:''},
            ConnectionType:{type:String,default:''},
            canEdit:{type:Boolean,default:true},
        },
        methods:{
            checkName(file){
                if(!file) return false;
                if(!file.name.startsWith(`VIA_Mobile360_${this.MainModel}_${this.ConnectionType.replace(/\s*/g,"")}_`) 
                  || !file.name.endsWith(".dbc")) {
                    this.$customAlert(`The DBC file should be named as VIA_Mobile360_${this.MainModel}_${this.ConnectionType.replace(/\s*/g,"")}_[tag].dbc.`);
                    return false;
                }
                return true;
            },
            handleChange(file, fileList){
                if(!this.uploadFailed && !this.checkName(file)){
                    fileList.splice(fileList.indexOf(file), 1);
                    return;
                }
                this.fileList = fileList;
                if(fileList.length > 0) {
                    this.selectDone = true;
                }else{
                     this.selectDone = false;
                }
               
            },
            handleRemove(file,fileList){
                this.fileList = fileList;
                this.selectDone = false;
                this.uploadFailed = false;
                this.$emit("uploadDone",null)
            },
            async uploadFile(fileParam){
                try {
                    this.urlData = await this.$serverApi.s3url.getUrl({action:'uploadVehicleModelDBCFile'}); 
                    if( !this.urlData) return
                    const formData = new FormData();
                    Object.entries(this.urlData.fields).forEach(([k,v])=>{
                        formData.append(k,v);
                    });
                    formData.append("file",fileParam.file);
                    await fetch(this.urlData.url,{
                        method:'post',
                        body:formData
                    }).then(res =>{
                        if(res.status === 204){
                            fileParam.onSuccess(true)
                            return Promise.resolve()
                        }
                        else{
                            return Promise.reject()
                        }
                    }).catch(error =>{
                        this.isUploading = false;
                        return Promise.reject()
                    })
                }catch(e){
                    this.isUploading = false;
                    return Promise.reject()
                }
            },
            submitUpload(){
                this.isUploading = true
                this.$refs.uploadDBC.submit()
            },
            handleSuccess(res,file,fileList){
                if(res){
                     fileList.splice(fileList.indexOf(file), 1);
                     this.isUploading = false;
                     this.$emit("uploadDone",{FToken:this.urlData.FToken,Path:this.getLocalUrl(file.raw),fileName: file.name})
                }
            },
            getLocalUrl(file) {
                let url = ''
                if (window.createObjectURL!=undefined) { // basic
                    url = window.createObjectURL(file) ;
                }else if (window.webkitURL!=undefined) { // webkit or chrome
                    url = window.webkitURL.createObjectURL(file) ;
                }else if (window.URL!=undefined) { // mozilla(firefox)
                    url = window.URL.createObjectURL(file) ;
                }
                return url;
            },
            handleError(res, file){
                this.isUploading = false;
                this.uploadFailed = true;
                this.$refs.uploadDBC.uploadFiles.push(file)
                file.name=`${file.name}（Failed）`
            },
        },
        mounted() {
            console.log("mounted")
        },
    }
</script>

<style lang="stylus"scoped>
    .upload-dbc-file
        display flex
        flex-direction row
        align-items center
        gap 20px
        .upload-dbc
            display flex
            flex-direction row
            align-items center
            >>>.el-upload-list__item:first-child
                margin-top 0px
        .dbc-button
            width 120px
            margin-right 20px
    .upload-dbc-readonly
        >>>.el-upload-list__item-status-label,>>>.el-icon-close,>>>el-icon-close-tip
            display none

    /deep/ li.el-upload-list__item.is-fail{
        .el-upload-list__item-name{
            color:red !important;
        }
    }
</style>